import type { ImportReport } from '@booknest/shared';

import { apiClient } from '@/shared/api/client.js';

interface ImportLibraryResponse {
  report: ImportReport;
}

export const importApi = {
  async importGoodreads(csv: string): Promise<ImportReport> {
    const { data } = await apiClient.post<ImportLibraryResponse>(
      '/import/goodreads',
      csv,
      { headers: { 'Content-Type': 'text/csv' } },
    );
    return data.report;
  },
};
